import React from "react";
import ListItemText from "@mui/material/ListItemText";
import LinearProgress from "@mui/material/LinearProgress";
import { getCollectionImportPresentation } from "../utils/collectionImport";

export default function CollectionImportStatus({ status, starting }) {
  const { label, detail, value } = getCollectionImportPresentation(
    status,
    starting,
  );
  return (
    <>
      <ListItemText
        primary={
          <span role="status" aria-live="polite">
            {label}
          </span>
        }
        secondary={detail || null}
      />
      <LinearProgress
        aria-label="Collection import progress"
        variant={value === null ? "indeterminate" : "determinate"}
        value={
          value === null ? undefined : Math.min(100, Math.max(0, value * 100))
        }
        sx={{ my: 1 }}
      />
    </>
  );
}
